// Tableware toggle
document.addEventListener('DOMContentLoaded', () => {
  initTablewareToggle();
  listenForCartChanges();
  initProfessionalToggle();
  checkProfessionalInput();
});
async function initTablewareToggle() {
  const tablewareContainer = document.querySelector('.cart__checkbox-tableware');
  if (!tablewareContainer) return;
  const tablewareProductId = parseInt(tablewareContainer.dataset.tablewareProductId, 10);
  if (!tablewareProductId) return;
  const tablewareCheckbox = tablewareContainer.querySelector('#tableware-product');
  if (!tablewareCheckbox) return;
  const newCheckbox = tablewareCheckbox.cloneNode(true);
  tablewareCheckbox.parentNode.replaceChild(newCheckbox, tablewareCheckbox);
  await checkTablewareInCart(tablewareProductId, newCheckbox);
  newCheckbox.addEventListener('change', async event => {
    if (event.target.checked) {
      await addTablewareToCart(tablewareProductId);
    } else {
      await removeTablewareFromCart(tablewareProductId);
    }
  });
}
function listenForCartChanges() {
  document.removeEventListener('click', handleCartRemoveButton);
  document.addEventListener('click', handleCartRemoveButton);
}
async function handleCartRemoveButton(event) {
  const removeButton = event.target.closest('cart-remove-button');
  if (removeButton) {
    setTimeout(async () => {
      const tablewareContainer = document.querySelector('.cart__checkbox-tableware');
      if (tablewareContainer) {
        const tablewareProductId = parseInt(tablewareContainer.dataset.tablewareProductId, 10);
        const tablewareCheckbox = tablewareContainer.querySelector('#tableware-product');
        if (tablewareProductId && tablewareCheckbox) {
          await checkTablewareInCart(tablewareProductId, tablewareCheckbox);
        }
      }
    }, 500);
  }
}
async function checkTablewareInCart(productId, checkbox) {
  try {
    const response = await fetch(window.Shopify.routes.root + 'cart.js');
    const cart = await response.json();
    const productInCart = cart.items.some(item => item.id === productId);
    checkbox.checked = productInCart;
  } catch (error) {
    console.error('Error checking cart:', error);
  }
}
async function addTablewareToCart(productId) {
  try {
    const formData = {
      'items': [{
        'id': productId,
        'quantity': 1
      }]
    };
    const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(formData)
    });
    const cart = await response.json();
    await refreshCart();
  } catch (error) {
    console.error('Error adding product to cart:', error);
  }
}
async function removeTablewareFromCart(productId) {
  try {
    const cartResponse = await fetch(window.Shopify.routes.root + 'cart.js');
    const cart = await cartResponse.json();
    const lineItem = cart.items.find(item => item.id === productId);
    if (lineItem) {
      const response = await fetch(window.Shopify.routes.root + 'cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          id: lineItem.key,
          quantity: 0
        })
      });
      await response.json();
      await refreshCart();
    } else {
      throw new Error('Product not found in cart');
    }
  } catch (error) {
    console.error('Error removing product from cart:', error);
  }
}
async function refreshCart() {
  try {
    // Fetch cart data
    const cartResponse = await fetch(window.Shopify.routes.root + 'cart.js');
    const cart = await cartResponse.json();

    // Refresh cart items
    const cartItemsResponse = await fetch(`${window.Shopify.routes.root}?section_id=main-cart-items`);
    const cartItemsResponseText = await cartItemsResponse.text();
    const cartItemsHtml = new DOMParser().parseFromString(cartItemsResponseText, 'text/html');
    const sourceQty = cartItemsHtml.querySelector('cart-items');
    const cartItems = document.querySelector('cart-items');
    if (cartItems && sourceQty) {
      cartItems.innerHTML = sourceQty.innerHTML;
    }
    const totalElement = document.querySelector('.totals__total-value');
    if (totalElement) {
      const priceInEuros = cart.total_price / 100;
      const formattedNumber = new Intl.NumberFormat('fr-FR', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format(priceInEuros);
      const formattedPrice = formattedNumber + '€';
      totalElement.textContent = formattedPrice;
    }
    await initTablewareToggle();
  } catch (error) {
    console.error('Error refreshing cart:', error);
  }
}

// Professional toggle
function initProfessionalToggle() {
  const professionalCheckbox = document.querySelector('#professional-input');
  if (!professionalCheckbox) return;
  professionalCheckbox.addEventListener('change', async event => {
    if (event.target.checked) {
      document.querySelector('.tva-input').classList.add('is-visible');
      document.querySelector('.siren-input').classList.add('is-visible');
      localStorage.setItem('professional-input-checked', 'true');
    } else {
      document.querySelector('.tva-input').classList.remove('is-visible');
      document.querySelector('.siren-input').classList.remove('is-visible');
      localStorage.setItem('professional-input-checked', 'false');
    }
  });
}
function checkProfessionalInput() {
  const professionalInputChecked = localStorage.getItem('professional-input-checked');
  if (professionalInputChecked === 'true') {
    document.querySelector('#professional-input').checked = true;
    document.querySelector('.tva-input').classList.add('is-visible');
    document.querySelector('.siren-input').classList.add('is-visible');
  } else {
    document.querySelector('#professional-input').checked = false;
    document.querySelector('.tva-input').classList.remove('is-visible');
    document.querySelector('.siren-input').classList.remove('is-visible');
  }
}